"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitObj = exports.pickObj = void 0;
const rambda_1 = require("rambda");
const pickObj = (obj, ...props) => {
    if (typeof props[0] === 'object')
        return (0, rambda_1.pick)(Object.keys(props[0]), obj);
    return (0, rambda_1.pick)(props, obj);
};
exports.pickObj = pickObj;
const omitObj = (obj, ...props) => {
    if (typeof props[0] === 'object')
        return (0, rambda_1.omit)(Object.keys(props[0]), obj);
    return (0, rambda_1.omit)(props, obj);
};
exports.omitObj = omitObj;
